import { render, staticRenderFns } from "./ControlInput.vue?vue&type=template&id=4be48312&"
import script from "./ControlInput.vue?vue&type=script&lang=js&"
export * from "./ControlInput.vue?vue&type=script&lang=js&"
import style0 from "./ControlInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports